<template>
    <div class="blockader">
        <admin-lock-border />
        <div class="header">
            <h1>Blockad</h1>
            <CustomButton type="button" variant="hollow" @click="openCreateBlockad">
                <img src="@/assets/plus_circle_blue.svg" />
                <span>Skapa ny blockad</span>
            </CustomButton>
        </div>

        <kliniken-table
            v-if="blockadList.results"
            :items="blockadList.results"
            paginationStyle="paging"
            :columns="columns"
            :count="count"
            :limit="limit"
            :currentPage="currentPage"
            @loadPage="loadPage"
            @changeLimit="changeLimit"
            @loadMore="loadMore"
            :showBottom="true"
            :showLimitDropdown="true"
            :has-dropdown="true"
            :dropdown-actions="dropdownActions"
            @edidBlockad="editBlockadFromTable"
        />
    </div>
</template>

<script>
    import tabIcon from "@/assets/gear.svg";

    export default {
        name: "ListBlockad",
        tabName: "Blockad",
        icon: tabIcon,
    };
</script>

<script setup>
    import { onMounted, ref, onBeforeUnmount } from "vue";
    import emitter from "tiny-emitter/instance";
    import { openDialog } from "@/utils";
    import AdminLockBorder from "@/components/AdminLockBorder.vue";
    import { getConfig, klinikenApi } from "@/api";
    import KlinikenTable from "@/components/Table/KlinikenTable.vue";
    import CustomButton from "@/components/Button.vue";
    import Blockad from "@/tabs/Admin/Blockad.vue";
    import store from "@/store";

    const blockadList = ref([]);
    const count = ref(0);
    const columns = ref([
        {
            title: "Namn",
            name: "displayName",
        },
        {
            title: "Ordningsnummer",
            name: "ordning",
        },
        {
            title: "System",
            name: "system",
        },
        {
            title: "Systemnamn",
            name: "systemName",
        },
        {
            title: "OrginalText",
            name: "originalText",
        },
    ]);
    const dropdownActions = ref([
        {
            name: "edidBlockad",
            title: "Redigera blockad",
            show: () => true,
        },
    ]);

    const limit = ref(50);
    const offset = ref(0);
    const fetchBatch = ref(1);
    const params = ref({});
    const currentPage = ref(1);

    const loadPage = async (page) => {
        currentPage.value = page;
        offset.value = (page - 1) * limit.value;
        await fetchblockadList();
    };

    const loadMore = async () => {
        fetchBatch.value++;
        await this.fetchblockadList();
    };

    const changeLimit = async (dropdownLimit) => {
        fetchBatch.value = 1;
        limit.value = dropdownLimit;
        await fetchblockadList();
    };

    const fetchblockadList = async () => {
        params.value = { ...params.value, limit: limit.value, offset: offset.value };
        if (limit.value > 0) {
            params.value["limit"] = limit.value * fetchBatch.value;
        }
        try {
            const response = await klinikenApi.get(
                "/operation/kodverk/blockader/",
                getConfig({ params: { ...params.value } })
            );
            blockadList.value = response.data;
            count.value = response.data.count;
        } catch (error) {
            openDialog("Kunde inte hämta Blockad.", "warning");
        }
    };
    const openCreateBlockad = () => {
        store.dispatch("tabs/openTab", {
            component: Blockad,
            parameters: { redigera: false },
        });
    };
    const editBlockadFromTable = (blockad) => {
        store.dispatch("tabs/openTab", {
            component: Blockad,
            parameters: {
                redigera: true,
                ...blockad,
            },
        });
    };

    onMounted(() => {
        fetchblockadList();
        emitter.on("Blockad-table-uppdaterad", fetchblockadList);
    });

    onBeforeUnmount(() => {
        emitter.off("Blockad-table-uppdaterad", fetchblockadList);
    });
</script>
<style lang="scss">
    .blockader {
        .header {
            h1 {
                margin: 0;
            }

            display: flex;
            gap: 20px;
            align-items: center;
        }
    }
</style>
